import datetimeUtils from '@/plugins/datetimeUtils';
import numberFormatter from '@/plugins/numberFormatter';
import i18n from '@/i18n';
import store from '@/store.js';

String.prototype.format = function () {
    var formatted = this;
    for (var arg in arguments) {
        if (arguments[arg] instanceof Array) {
            arguments[arg].forEach((a, idx) => {
                formatted = formatted.replace("{" + idx + "}", a);
            })
        } else {
            formatted = formatted.replace("{" + arg + "}", arguments[arg]);
        }
    }
    return formatted;
};

function getSum(obj, factors, format) {
    if (factors && factors.length > 0) {
        if (factors.length == 1) {
            return getField(obj, factors[0], format);
        } else {
            var sum = 1;
            factors.forEach(factor => {
                sum *= getField(obj, factor, format);
            })
            return sum;
        }
    } else {
        return 0;
    }
}

function getSub(obj, format) {
    if (format.subtrahend && format.minuend) {
        return Number(getField(obj, format.subtrahend, format)) - Number(getField(obj, format.minuend, format));
    } else {
        return 0;
    }
}

function getField(obj, field, format) {
    var tags = field.split('.');
    switch (tags[0]) { // 特殊变量
        // 系统变量
        case "_now":
            return datetimeUtils.formatTime(new Date());
        case "_login":
            return store.state.accountUser[field.replace("_login.", "")];
        case "_account":
            return store.state.accountInfo[field.replace("_account.", "")];
        // 计算变量
        case "_sum":
            return getSum(obj, format.factors, format);
        case "_sub":
            return getSub(obj, format);
    }
    var child = obj;
    for (var idx = 0; idx < tags.length; idx++) {
        if (child[tags[idx]] == undefined) {
            return "";
        }
        child = child[tags[idx]];
    }
    return child ? child : "";
}

function getValue(obj, format) {
    if (format.formater && format.fields) {
        var args = format.fields.map(field => {
            return getField(obj, field, format);
        })
        val = format.formater.format(args);
        if (!val.trim() && format.fieldsFallback) {
            args = format.fieldsFallback.map(field => {
                return getField(obj, field, format);
            })
            val = format.formater.format(args);
        }
        return val;
    } else if (format.field || format.fieldFallback) {
        var val = getField(obj, format.field, format)
        if (!val)
            val = format.fieldFallback ? getField(obj, format.fieldFallback, format) : "";
        if (format.format) {
            switch (format.format) {
                case "date":
                    val = datetimeUtils.formatDate(val);
                    break;
                case "datetime":
                    val = datetimeUtils.formatTime(val);
                    break;
                case "date_only_time":
                case "dateOnlyTime":
                    val = datetimeUtils.formatOnlyTime(val);
                    break;
                case "date_add_days":
                case "dateAddDays":
                    val = datetimeUtils.formatDate(datetimeUtils.addDays(new Date(val), format.add_days));
                    break;
                case "date_add_time":
                case "dateAddTime":
                    val = datetimeUtils.formatDate(datetimeUtils.addTime(new Date(val),
                        (format.add_days ? format.add_days : 0) * 24 * 60 * 60 * 1000 +
                        (format.add_hours ? format.add_hours : 0) * 60 * 60 * 1000 +
                        (format.add_minutes ? format.add_minutes : 0) * 60 * 1000 +
                        (format.add_seconds ? format.add_seconds : 0) * 1000));
                    break;
                case "datetime_add_time":
                case "datetimeAddTime":
                    val = datetimeUtils.formatTime(datetimeUtils.addTime(new Date(val),
                        (format.add_days ? format.add_days : 0) * 24 * 60 * 60 * 1000 +
                        (format.add_hours ? format.add_hours : 0) * 60 * 60 * 1000 +
                        (format.add_minutes ? format.add_minutes : 0) * 60 * 1000 +
                        (format.add_seconds ? format.add_seconds : 0) * 1000));
                    break;
                case "remain_days":
                case "remainDays":
                    val = datetimeUtils.remainDays(val);
                    break;
                case "readable_time":
                case "readableTime":
                    val = datetimeUtils.readableTime(val);
                    break;
                case "money":
                    val = !isNaN(Number(val))? i18n.t("Global.money") + numberFormatter.formatWithMoney(val, false):val;
                    break;
                case "money_less_than_zero":
                case "moneyLessThanZero":
                    val = i18n.t("Global.money") + numberFormatter.formatWithMoney(val, true);
                    break;
                case "big_money"://金额大写
                case "bigMoney"://金额大写
                    val = numberFormatter.digitUppercase(numberFormatter.formatWithDot(val, 2, false));// 大写金额取两位小数，无负数
                    break;
                case "dot_2":
                case "dot2":
                    val = numberFormatter.formatWithDot(val, 2, true);
                    break;
                case "dot_no_more_than_2":
                case "dotNoMoreThan2":
                    val = numberFormatter.formatWithDotNoMoreThan(val, 2, true);
                    break;
                case "dot":
                    val = numberFormatter.formatWithDot(val, format.precision, true);
                    break;
                case "dot_no_more_than":
                case "dotNoMoreThan":
                    val = numberFormatter.formatWithDotNoMoreThan(val, format.precision, true);
                    break;
            }
        }
        return val;
    } else {
        return "";
    }
}

function addCitiesName(obj) {
    if (store.state.citiesMap) {
        if (obj.province_id && !obj.province_name)
            obj.province_name = store.state.citiesMap[obj.province_id];
        if (obj.city_id && !obj.city_name)
            obj.city_name = store.state.citiesMap[obj.city_id];
        if (obj.area_id && !obj.area_name)
            obj.area_name = store.state.citiesMap[obj.area_id];
    }
    return obj;
}

export default {
    getField,
    getValue,
    addCitiesName,
}